/**
 * Mounts the Help Center at the app root, only while it's open. Rendered inside
 * <App/> so it shares the toast/confirm hosts.
 */

import { useHelpStore } from '@/state/helpStore.js';
import HelpCenter from './HelpCenter.jsx';

export default function HelpMount() {
  const open = useHelpStore((s) => s.open);
  return open ? <HelpCenter /> : null;
}
